import { edgeApi } from '@lib/apiClients.ts';
import { microServicesRoutes } from '@constants';
import { type ApiResponse, type CalendarResponse } from '@types';
import { extractErrorMessage } from '@lib/logger/extractErrorMessage.ts';
import { logError } from '@lib/logger/logError.ts';

const handleError = <T = never>(
  message: string,
  error: unknown,
  source: string,
): ApiResponse<T> => {
  const errorMessage = extractErrorMessage(error);

  void logError(
    message,
    source,
    {
      error: errorMessage,
      rawError: error,
    },
    true,
  );

  return {
    success: false,
    error: {
      message,
      raw: errorMessage,
    },
  };
};

async function getCalendlyApi (userId: string, cache: boolean): Promise<ApiResponse<CalendarResponse>> {
  try {
    const sessions = await edgeApi.get<CalendarResponse>(`${microServicesRoutes.edge.get.calendar.getSessions}/${userId}`, {
      params: { cache },
    });
      
    return {
      data: sessions.data,
      success: true
    };

  } catch (e) {
    return handleError<CalendarResponse>('Error getting Calendly sessions', e, 'Edge getCalendar');
  }
}

export default getCalendlyApi;